import request from '@/utils/request'
import qs from 'qs'
import { Logical, Request } from '@/types/logical'

/**
 * Runtime logical
 */
export function Runtime(d: Request): Promise<string> {
  return request.put(`/logical/${d.id}`, qs.stringify(d))
}

/**
 * Find logical
 */
export function Find(params?: Request): Promise<Array<Logical>> {
  return request.get('/logical', { params })
}

/**
 * Get logical
 */
export function Get(d: string): Promise<Logical> {
  return request.get(`/logical/${d}`)
}

/**
 * Post logical
 * @param id Logical id
 */
export function Post(d: Request): Promise<number> {
  console.log(d)
  if (d.id) {
    return request.post(`/logical/${d.id}`)
  }

  return request.post('/logical', qs.stringify(d))
}

/**
 * Patch logical
 * @param d Logical data
 */
export function Patch(d: Request): Promise<number> {
  return request.patch(`/logical/${d.id}`, d)
}

/**
 * Delete logical
 * @param d Logical data
 */
export function Delete(d: Request): Promise<number> {
  return request.delete(`/logical/${d.id}`, { params: { version: d.ver } })
}
